import { css } from '@emotion/react';
import { IonCol, IonContent, IonGrid, IonModal, IonRow, IonText } from '@ionic/react';
import React from 'react';
import * as commonCss from '../../styles/common';
import ModalHeader from '../ModalHeader';
import LoginSection from './LoginSection';
import { useUser } from '../../contexts/UserContext';

interface LoginModalProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  title: string;
  promptText: string;
}

export const LoginModal: React.FC<LoginModalProps> = ({ isOpen, setIsOpen, title, promptText }) => {
  const [isEmailSubmitted, setIsEmailSubmitted] = React.useState(false);
  const [email, setEmail] = React.useState('');
  const { sendSignInLinkToEmail } = useUser();

  const handleSendSignInLink = async (email: string) => {
    await sendSignInLinkToEmail(email);
    setIsEmailSubmitted(true);
    setEmail(email);
  };

  const onClose = React.useCallback(() => {
    setIsOpen(false);
    setIsEmailSubmitted(false);
  }, [setIsOpen]);

  const modalCss = {
    modal: [
      css({
        '--max-height': '350px',
        '--max-width': '400px',
      }),
    ],
    itemStyle: css({
      padding: '1rem',
    }),
    emailSpan: css({
      textDecoration: 'underline',
      color: '#00aeec',
    }),
  };

  return (
    <IonModal isOpen={isOpen} onDidDismiss={onClose} css={modalCss.modal}>
      <ModalHeader onClose={onClose} title={title} />
      <IonContent className="ion-padding">
        <IonGrid>
          {!isEmailSubmitted ? (
            <>
              <IonRow>
                <IonCol css={commonCss.centered}>{promptText}</IonCol>
              </IonRow>
              <IonRow>
                <IonCol>
                  <LoginSection onSendSignInLink={handleSendSignInLink} />
                </IonCol>
              </IonRow>
            </>
          ) : (
            <IonRow>
              <IonCol>
                <IonText css={modalCss.itemStyle}>
                  <p>
                    We sent a verification link to <span css={modalCss.emailSpan}>{email}</span>. Please check your
                    inbox and click on the link to enable notifications.
                  </p>
                </IonText>
              </IonCol>
            </IonRow>
          )}
        </IonGrid>
      </IonContent>
    </IonModal>
  );
};
